import React from 'react';

const CourseDiscussion = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Course Discussions</h1>
      <p className="text-gray-600">Discussion forum coming soon...</p>
    </div>
  );
};

export default CourseDiscussion;